<template>
  <div class="Layout">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "SimpleLayout",
};
</script>
<style lang="less">
@import "@/assets/style/layout.less";
.Layout {
  min-width: 1200px;
  min-height: calc(100vh - @footer-height - @header-height);
  background-color: #fff;
}
</style>
